// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1P0h2","row":"styles_row__3WU9L"};